import { Injectable } from '@angular/core';
import { AbstractOrganizationService } from './abstractOrganizationService';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { Timestamp } from '../models/audit';
import { buildHttpParams } from '@shared/utils/request-utils';
import { PageParams } from './logs/logs.service';
import { SpringPage } from '@shared/page';

@Injectable({
  providedIn: 'root',
})
export class OrganizationJournalService extends AbstractOrganizationService {
  constructor(
    protected readonly http: HttpClient,
    auth: AuthService,
  ) {
    super(auth);
  }

  public getJournalEvents(query: Partial<JournalQuery>, pageParams: PageParams): Observable<SpringPage<JournalEvent>> {
    return this.http.get<SpringPage<JournalEvent>>(this.url('/journal'), {
      params: buildHttpParams({ ...pageParams, ...query }),
    });
  }
  public getSubTypes(): Observable<EventSubTypeOption[]> {
    return this.http.get<EventSubTypeOption[]>('v2/journal/subtypes');
  }
}

export type JournalQuery = {
  cluster: string;
  sites: string[];
  tags: string[];
  afterEvent: Timestamp;
  after: Timestamp;
  before: Timestamp;
  type: readonly EventType[];
  subtype: readonly string[];
  severity: EventSeverity;
  ip: string;
};

export enum EventSeverity {
  'LOW' = 1,
  'MEDIUM' = 2,
  'HIGH' = 3,
}

export const EventTypes = ['SECURITY', 'MONITORING', 'ACTIVITY'] as const;
export type EventType = (typeof EventTypes)[number];
export interface EventSubTypeOption {
  code: string;
  label: string;
  type: EventType;
}
export type JournalEvent = {
  id: number;
  clusterUid: string;
  site: string;
  type: EventType;
  subtype: string;
  subtypeLabel: string;
  severity: 1 | 2 | 3;
  date: Timestamp;
  userEmail: string;
  event: any;
  experimental: boolean;
};
